import GeneralEmailCampaign from "../../../components/Pages/Campaign/General/Email";

const GeneralEmail = () => {
  return (
    <div>
      <GeneralEmailCampaign />
    </div>
  );
};

export default GeneralEmail;
